import {
  ApiOutlined,
  ContainerOutlined,
  DesktopOutlined,
  GoldOutlined,
  HomeOutlined,
  ProductOutlined,
  SettingOutlined,
  StockOutlined,
  UserOutlined,
  // NotificationFilled
} from '@ant-design/icons'

import { ControleAcessoOperacoes } from 'Components/Acesso/ControleAcessoOperacoes'

const menuItems = [
  // {
  //   key: 'novidade',
  //   icon: <NotificationFilled />,
  //   label: 'Novidades',
  //   path: '/novidade'
  // },
  {
    key: '/',
    icon: <HomeOutlined />,
    label: 'Dashboard',
    path: '/',
  },
  {
    key: 'vendas',
    icon: <DesktopOutlined />,
    label: 'Vendas - Configuração / Análise',
    subitems: [
      {
        key: 'configuracao-vendas',
        label: 'Configuração de Vendas',
        subitems: [
          {
            key: 'adquirente-tef',
            label: 'Adquirente TEF',
            path: '/cadastro/adquirente-tef',
            permission: [
              ControleAcessoOperacoes.AdquirenteTef,
              ControleAcessoOperacoes.AdquirenteTefAdicionar,
              ControleAcessoOperacoes.AdquirenteTefAlterar,
              ControleAcessoOperacoes.AdquirenteTefRemover,
              ControleAcessoOperacoes.AdquirenteTefListar,
            ],
          },
          {
            key: 'bandeira-tef',
            label: 'Bandeira TEF',
            path: '/cadastro/bandeira-tef',
            permission: [
              ControleAcessoOperacoes.BandeiraTef,
              ControleAcessoOperacoes.BandeiraTefAdicionar,
              ControleAcessoOperacoes.BandeiraTefAlterar,
              ControleAcessoOperacoes.BandeiraTefRemover,
              ControleAcessoOperacoes.BandeiraTefListar,
            ],
          },
          {
            key: 'cartao-consumo',
            label: 'Cartão de Consumo',
            path: '/cadastro/cartao-consumo',
            permission: [
              ControleAcessoOperacoes.CartaoConsumo,
              ControleAcessoOperacoes.CartaoConsumoAdicionar,
              ControleAcessoOperacoes.CartaoConsumoAlterar,
              ControleAcessoOperacoes.CartaoConsumoRemover,
              ControleAcessoOperacoes.CartaoConsumoListar,
            ],
          },
          {
            key: 'disp-movel',
            label: 'Dispositivos Móveis',
            path: '/cadastro/disp-movel',
            permission: [
              ControleAcessoOperacoes.DispositivoMovel,
              ControleAcessoOperacoes.DispositivoMovelAdicionar,
              ControleAcessoOperacoes.DispositivoMovelAlterar,
              ControleAcessoOperacoes.DispositivoMovelRemover,
              ControleAcessoOperacoes.DispositivoMovelListar,
            ],
          },
          {
            key: 'forma-pgto',
            label: 'Formas de Pagamento',
            path: '/cadastro/forma-pgto',
            permission: [
              ControleAcessoOperacoes.FormaPagamento,
              ControleAcessoOperacoes.FormaPagamentoAdicionar,
              ControleAcessoOperacoes.FormaPagamentoAlterar,
              ControleAcessoOperacoes.FormaPagamentoRemover,
              ControleAcessoOperacoes.FormaPagamentoListar,
            ],
          },
          {
            key: 'gatilho',
            label: 'Gatilhos',
            path: '/cadastro/gatilho',
            permission: [
              ControleAcessoOperacoes.Gatilho,
              ControleAcessoOperacoes.GatilhoAdicionar,
              ControleAcessoOperacoes.GatilhoAlterar,
              ControleAcessoOperacoes.GatilhoRemover,
              ControleAcessoOperacoes.GatilhoListar,
            ],
          },
          {
            key: 'impressora-comanda',
            label: 'Impressoras de Comanda',
            path: '/cadastro/impressora-comanda',
            permission: [
              ControleAcessoOperacoes.ImpressoraComanda,
              ControleAcessoOperacoes.ImpressoraComandaAdicionar,
              ControleAcessoOperacoes.ImpressoraComandaAlterar,
              ControleAcessoOperacoes.ImpressoraComandaRemover,
              ControleAcessoOperacoes.ImpressoraComandaListar,
            ],
          },
          {
            key: 'maquina-pos',
            label: 'Máquina POS',
            path: '/cadastro/maquina-pos',
            permission: [
              ControleAcessoOperacoes.MaquinaPOS,
              ControleAcessoOperacoes.MaquinaPOSAdicionar,
              ControleAcessoOperacoes.MaquinaPOSAlterar,
              ControleAcessoOperacoes.MaquinaPOSRemover,
              ControleAcessoOperacoes.MaquinaPOSListar,
            ],
          },
          {
            key: 'mesa',
            label: 'Mesa',
            path: '/cadastro/mesa',
            permission: [
              ControleAcessoOperacoes.Mesa,
              ControleAcessoOperacoes.MesaAdicionar,
              ControleAcessoOperacoes.MesaAlterar,
              ControleAcessoOperacoes.MesaRemover,
              ControleAcessoOperacoes.MesaListar,
            ],
          },
          {
            key: 'modalidade-tef',
            label: 'Modalidade TEF',
            path: '/cadastro/modalidade-tef',
            permission: [
              ControleAcessoOperacoes.ModalidadeTef,
              ControleAcessoOperacoes.ModalidadeTefAdicionar,
              ControleAcessoOperacoes.ModalidadeTefAlterar,
              ControleAcessoOperacoes.ModalidadeTefRemover,
              ControleAcessoOperacoes.ModalidadeTefListar,
            ],
          },
          {
            key: 'motivo-cancela',
            label: 'Motivo de Cancelamento',
            path: '/cadastro/motivo-cancela',
            permission: [
              ControleAcessoOperacoes.MotivoCancelamento,
              ControleAcessoOperacoes.MotivoCancelamentoAdicionar,
              ControleAcessoOperacoes.MotivoCancelamentoAlterar,
              ControleAcessoOperacoes.MotivoCancelamentoRemover,
              ControleAcessoOperacoes.MotivoCancelamentoListar,
            ],
          },
          {
            key: 'motivo-transfere',
            label: 'Motivo de Transferência',
            path: '/cadastro/motivo-transfere',
            permission: [
              ControleAcessoOperacoes.MotivoTransferencia,
              ControleAcessoOperacoes.MotivoTransferenciaAdicionar,
              ControleAcessoOperacoes.MotivoTransferenciaAlterar,
              ControleAcessoOperacoes.MotivoTransferenciaRemover,
              ControleAcessoOperacoes.MotivoTransferenciaListar,
            ],
          },
          {
            key: 'op-nao-fiscal',
            label: 'Operação não Fiscal',
            path: '/cadastro/op-nao-fiscal',
            permission: [
              ControleAcessoOperacoes.OperacaoNaoFiscal,
              ControleAcessoOperacoes.OperacaoNaoFiscalAdicionar,
              ControleAcessoOperacoes.OperacaoNaoFiscalAlterar,
              ControleAcessoOperacoes.OperacaoNaoFiscalRemover,
              ControleAcessoOperacoes.OperacaoNaoFiscalListar,
            ],
          },
          {
            key: 'pdv',
            label: 'PDV',
            path: '/cadastro/pdv',
            permission: [
              ControleAcessoOperacoes.Pdv,
              ControleAcessoOperacoes.PdvAdicionar,
              ControleAcessoOperacoes.PdvAlterar,
              ControleAcessoOperacoes.PdvRemover,
              ControleAcessoOperacoes.PdvListar,
            ],
          },
          {
            key: 'praca',
            label: 'Praça',
            path: '/cadastro/praca',
            permission: [
              ControleAcessoOperacoes.Praca,
              ControleAcessoOperacoes.PracaAdicionar,
              ControleAcessoOperacoes.PracaAlterar,
              ControleAcessoOperacoes.PracaRemover,
              ControleAcessoOperacoes.PracaListar,
            ],
          },
        ],
      },
      {
        key: 'relatorio-gestao-comandas',
        label: 'Relatório e Gestão de Comandas',
        subitems: [
          {
            key: 'vouchers',
            label: 'Vouchers',
            path: '/relatorio/vouchers',
            permission: ControleAcessoOperacoes.Vouchers,
          },
          {
            key: 'acompanhamento-prevendas',
            label: 'Acompanhamento de Pré-Vendas',
            path: '/relatorio/acompanhamento-prevendas',
            permission: ControleAcessoOperacoes.AcompanhamentoPreVendas,
          },
          {
            key: 'acompanhamento-prevendas-delivery',
            label: 'Acompanhamento de Pré-Vendas (Delivery)',
            path: '/relatorio/acompanhamento-prevendas-delivery',
            permission: ControleAcessoOperacoes.AcompanhamentoPreVendasDelivery,
          },
          {
            key: 'agenda-encomendas',
            label: 'Agendamento de Encomendas',
            path: '/relatorio/agenda-encomendas',
            permission: ControleAcessoOperacoes.AgendamentoEncomendas,
          },
          {
            key: 'operacoes-nao-fiscais',
            label: 'Operações Não Fiscais',
            path: '/relatorio/operacoes-nao-fiscais',
            permission: ControleAcessoOperacoes.OperacoesNaoFiscais,
          },
          {
            key: 'cancelamento-prevendas',
            label: 'Cancelamento de Pré-Vendas',
            path: '/relatorio/cancelamento-prevendas',
            permission: ControleAcessoOperacoes.CancelamentoPreVendas,
          },
        ],
      },
      {
        key: 'relatorios-vendas',
        label: 'Relatórios de Vendas',
        subitems: [
          {
            key: 'curva-abc',
            label: 'Curva ABC',
            path: '/relatorio/curva-abc',
            permission: ControleAcessoOperacoes.CurvaABC,
          },
          {
            key: 'faturamento-diario-mensal',
            label: 'Faturamento Diário/Mensal',
            path: '/relatorio/faturamento-diario-mensal',
            permission: ControleAcessoOperacoes.FaturamentoDiarioMensal,
          },
          {
            key: 'produtos-por-cliente',
            label: 'Produtos Por Cliente',
            path: '/relatorio/produtos-por-cliente',
            permission: ControleAcessoOperacoes.ProdutosPorCliente,
          },
          {
            key: 'produtos-vendidos-por-operador',
            label: 'Produtos Vendidos por Operador',
            path: '/relatorio/produtos-vendidos-por-operador',
            permission: ControleAcessoOperacoes.ProdutosVendidosOperador,
          },
          {
            key: 'vendas',
            label: 'Vendas',
            path: '/relatorio/vendas',
            permission: ControleAcessoOperacoes.Vendas,
          },
          {
            key: 'venda-por-categoria',
            label: 'Vendas por Categoria',
            path: '/relatorio/venda-por-categoria',
            permission: ControleAcessoOperacoes.VendasCategoria,
          },
          {
            key: 'vendas-canceladas',
            label: 'Vendas Canceladas',
            path: '/relatorio/vendas-canceladas',
            permission: ControleAcessoOperacoes.VendasCanceladas,
          },
          {
            key: 'vendas-por-cliente',
            label: 'Vendas por Cliente',
            path: '/relatorio/vendas-por-cliente',
            permission: ControleAcessoOperacoes.VendasCliente,
          },
          {
            key: 'vendas-eadelivery',
            label: 'Vendas EADelivery',
            path: '/relatorio/vendas-eadelivery',
            permission: ControleAcessoOperacoes.ResumoVendasEADelivery,
          },
          {
            key: 'venda-por-forma-pgto',
            label: 'Vendas por Forma de Pagamento',
            path: '/relatorio/venda-por-forma-pgto',
            permission: ControleAcessoOperacoes.VendasFormaPagamento,
          },
          {
            key: 'venda-por-produto',
            label: 'Vendas por Produto',
            path: '/relatorio/venda-por-produto',
            permission: ControleAcessoOperacoes.VendasProduto,
          },

          {
            key: 'venda-por-operador',
            label: 'Vendas por Operador',
            path: '/relatorio/venda-por-operador',
            permission: ControleAcessoOperacoes.VendasOperador,
          },
          {
            key: 'venda-atendente',
            label: 'Vendas por Atendente',
            path: '/relatorio/venda-atendente',
            permission: ControleAcessoOperacoes.RelatorioVendasPorAtendente,
          },
          {
            key: 'venda-atendente-detalhe',
            label: 'Vendas por Atendente Detalhe',
            path: '/relatorio/venda-atendente-detalhe',
            permission: ControleAcessoOperacoes.RelatorioVendasPorAtendenteDetalhe,
          },
        ],
      },
      {
        key: 'analise-desempenho',
        label: 'Análise de Desempenho',
        subitems: [
          {
            key: 'desempenho-atendente',
            label: 'Desempenho de Atendente',
            path: '/relatorio/desempenho-atendente',
            permission: ControleAcessoOperacoes.DesempenhoAtendente,
          },
          {
            key: 'desempenho-entregador',
            label: 'Desempenho de Entregador',
            path: '/relatorio/desempenho-entregador',
            permission: ControleAcessoOperacoes.DesempenhoEntregador,
          },
          {
            key: 'taxa-servico-por-garcom',
            label: 'Taxa de Serviço por Garçom',
            path: '/relatorio/taxa-servico-por-garcom',
            permission: ControleAcessoOperacoes.TaxaServicoGarcom,
          },
          {
            key: 'taxa-servico-por-data',
            label: 'Taxa de Serviço por Data',
            path: '/relatorio/taxa-servico-por-data',
            permission: ControleAcessoOperacoes.TaxaServicoData,
          },
          {
            key: 'ticket-medio-cliente-pracas',
            label: 'Ticket Médio Cliente por Pracas',
            path: '/relatorio/ticket-medio-cliente-por-pracas',
            permission: ControleAcessoOperacoes.TicketMedioClientePracas,
          },
          {
            key: 'venda-lucro-mensal',
            label: 'Lucro Mensal',
            path: '/relatorio/venda-lucro-mensal',
            permission: ControleAcessoOperacoes.LucroMensal,
          },
          {
            key: 'venda-lucro-por-produto',
            label: 'Lucro por Produto',
            path: '/relatorio/venda-lucro-por-produto',
            permission: ControleAcessoOperacoes.LucroProduto,
          },
          {
            key: 'auditoria-vendas-por-praca',
            label: 'Auditoria de Vendas por Praca',
            path: '/relatorio/auditoria-vendas-por-praca',
            permission: ControleAcessoOperacoes.AuditoriaVendasPraca,
          },
          {
            key: 'venda-por-produtos-auditoria',
            label: 'Auditoria de vendas por Produto',
            path: '/relatorio/venda-por-produtos-auditoria',
            permission: ControleAcessoOperacoes.AuditoriaVendasProdutos,
          },
          {
            key: 'auditoria-vendas-varejofacil',
            label: 'Auditoria de Vendas VarejoFacil',
            path: '/relatorio/auditoria-vendas-varejofacil',
            permission: ControleAcessoOperacoes.AuditoriaVendasVarejofacil,
          },
          {
            key: 'auditoria-taxa-servico',
            label: 'Auditoria de Taxa de Serviço',
            path: '/relatorio/auditoria-taxa-servico',
            permission: ControleAcessoOperacoes.AuditoriaTaxaServico,
          },
          {
            key: 'raio-x',
            label: 'Raio X',
            path: '/relatorio/raio-x',
            permission: ControleAcessoOperacoes.RaioX,
          },
        ],
      },
    ],
  },
  {
    key: 'produtos',
    // eslint-disable-next-line react/jsx-no-undef
    icon: <ProductOutlined />,
    label: 'Produtos',
    subitems: [
      {
        key: 'produto',
        label: 'Produto',
        path: '/cadastro/produto',
        permission: [
          ControleAcessoOperacoes.Produto,
          ControleAcessoOperacoes.ProdutoAdicionar,
          ControleAcessoOperacoes.ProdutoAlterar,
          ControleAcessoOperacoes.ProdutoRemover,
          ControleAcessoOperacoes.ProdutoListar,
        ],
      },
      {
        key: 'grupo-produto',
        label: 'Grupo de produtos',
        path: '/cadastro/grupo-produto',
        permission: [
          ControleAcessoOperacoes.GrupoProdutos,
          ControleAcessoOperacoes.GrupoProdutosAdicionar,
          ControleAcessoOperacoes.GrupoProdutosAlterar,
          ControleAcessoOperacoes.GrupoProdutosRemover,
          ControleAcessoOperacoes.GrupoProdutosListar,
        ],
      },

      {
        key: 'alteracao-em-massa',
        label: 'Alteração grupo produto em massa',
        path: 'cadastro/alteracao-em-massa',
      },
      {
        key: 'opcao',
        label: 'Opção',
        path: '/cadastro/opcao',
        permission: [
          ControleAcessoOperacoes.Opcao,
          ControleAcessoOperacoes.OpcaoAdicionar,
          ControleAcessoOperacoes.OpcaoAlterar,
          ControleAcessoOperacoes.OpcaoRemover,
          ControleAcessoOperacoes.OpcaoListar,
        ],
      },
      {
        key: 'grupo-opcao',
        label: 'Grupo de opções',
        path: '/cadastro/grupo-opcao',
        permission: [
          ControleAcessoOperacoes.GrupoOpcao,
          ControleAcessoOperacoes.GrupoOpcaoAdicionar,
          ControleAcessoOperacoes.GrupoOpcaoAlterar,
          ControleAcessoOperacoes.GrupoOpcaoRemover,
          ControleAcessoOperacoes.GrupoOpcaoListar,
        ],
      },
      {
        key: 'disponibilidade',
        label: 'Disponibilidade de produtos',
        path: '/cadastro/disponibilidade',
        permission: [
          ControleAcessoOperacoes.DisponibilidadeProdutos,
          ControleAcessoOperacoes.DisponibilidadeProdutosAdicionar,
          ControleAcessoOperacoes.DisponibilidadeProdutosAlterar,
          ControleAcessoOperacoes.DisponibilidadeProdutosRemover,
          ControleAcessoOperacoes.DisponibilidadeProdutosListar,
        ],
      },
      {
        key: 'tabela-preco',
        label: 'Tabela de preço',
        path: '/cadastro/tabela-preco',
        permission: [
          ControleAcessoOperacoes.TabelaPreco,
          ControleAcessoOperacoes.TabelaPrecoAdicionar,
          ControleAcessoOperacoes.TabelaPrecoAlterar,
          ControleAcessoOperacoes.TabelaPrecoRemover,
          ControleAcessoOperacoes.TabelaPrecoListar,
        ],
      },
      {
        key: 'unidade',
        label: 'Unidade',
        path: '/cadastro/unidade',
        permission: [
          ControleAcessoOperacoes.Unidade,
          ControleAcessoOperacoes.UnidadeAdicionar,
          ControleAcessoOperacoes.UnidadeAlterar,
          ControleAcessoOperacoes.UnidadeRemover,
          ControleAcessoOperacoes.UnidadeListar,
        ],
      },
      {
        key: 'tara-balanca',
        label: 'Tara de balança',
        path: '/cadastro/tara-balanca',
        permission: [
          ControleAcessoOperacoes.Tara,
          ControleAcessoOperacoes.TaraAdicionar,
          ControleAcessoOperacoes.TaraAlterar,
          ControleAcessoOperacoes.TaraRemover,
          ControleAcessoOperacoes.TaraListar,
        ],
      },
      {
        key: 'setor-producao',
        label: 'Setor de produção',
        path: '/cadastro/setor-producao',
        permission: [
          ControleAcessoOperacoes.SetorProducao,
          ControleAcessoOperacoes.SetorProducaoAdicionar,
          ControleAcessoOperacoes.SetorProducaoAlterar,
          ControleAcessoOperacoes.SetorProducaoRemover,
          ControleAcessoOperacoes.SetorProducaoListar,
        ],
      },
      {
        key: 'relatorios-produtos',
        label: 'Relatórios',
        subitems: [
          {
            key: 'informacoes-produtos',
            label: 'Informações de produtos',
            path: '/relatorio/informacoes-produtos',
            permission: ControleAcessoOperacoes.InformacoesProdutos,
          },
        ],
      },
    ],
  },
  {
    key: 'clientes',
    icon: <UserOutlined />,
    label: 'Clientes',
    subitems: [
      {
        key: 'pessoa',
        label: 'Pessoa/Cliente',
        path: '/cadastro/pessoa',
        permission: [
          ControleAcessoOperacoes.Pessoa,
          ControleAcessoOperacoes.PessoaAdicionar,
          ControleAcessoOperacoes.PessoaAlterar,
          ControleAcessoOperacoes.PessoaRemover,
          ControleAcessoOperacoes.PessoaListar,
        ],
      },
      {
        key: 'bairro',
        label: 'Bairro',
        path: '/cadastro/bairro',
        permission: [
          ControleAcessoOperacoes.Bairro,
          ControleAcessoOperacoes.BairroAdicionar,
          ControleAcessoOperacoes.BairroAlterar,
          ControleAcessoOperacoes.BairroRemover,
          ControleAcessoOperacoes.BairroListar,
        ],
      },
      {
        key: 'cidade',
        label: 'Cidade',
        path: '/cadastro/cidade',
        permission: [
          ControleAcessoOperacoes.Cidade,
          ControleAcessoOperacoes.CidadeAdicionar,
          ControleAcessoOperacoes.CidadeAlterar,
          ControleAcessoOperacoes.CidadeRemover,
          ControleAcessoOperacoes.CidadeListar,
        ],
      },
      {
        key: 'regiao',
        label: 'Região',
        path: '/cadastro/regiao',
        permission: [
          ControleAcessoOperacoes.Regiao,
          ControleAcessoOperacoes.RegiaoAdicionar,
          ControleAcessoOperacoes.RegiaoAlterar,
          ControleAcessoOperacoes.RegiaoRemover,
          ControleAcessoOperacoes.RegiaoListar,
        ],
      },
      {
        key: 'relatorios-pessoas-clientes',
        label: 'Relatórios',
        subitems: [
          {
            key: 'consumo-clientes',
            label: 'Consumo de clientes',
            path: '/relatorio/consumo-clientes',
            permission: ControleAcessoOperacoes.ConsumoClientes,
          },
          {
            key: 'listagem-clientes',
            label: 'Listagem de clientes',
            path: '/relatorio/listagem-clientes',
            permission: ControleAcessoOperacoes.ListagemClientes,
          },
          {
            key: 'ranking-clientes',
            label: 'Ranking de clientes',
            path: '/relatorio/ranking-clientes',
            permission: ControleAcessoOperacoes.RankingClientes,
          },
          {
            key: 'clientes-que-nao-compraram',
            label: 'Clientes que nao compraram',
            path: '/relatorio/clientes-que-nao-compraram',
            permission: ControleAcessoOperacoes.ClientesNaoCompraram,
          },
          // {
          //   key: 'produtos-por-cliente',
          //   label: 'Produtos por cliente',
          //   path: '/relatorio/produtos-por-cliente',
          //   permission: ControleAcessoOperacoes.ProdutosCliente
          // }
        ],
      },
    ],
  },
  {
    key: 'fiscal',
    icon: <ContainerOutlined />,
    label: 'Fiscal',
    subitems: [
      {
        key: 'documentos-fiscais',
        label: 'Documentos Fiscais',
        subitems: [
          {
            key: 'extrair-cfe',
            label: 'Extrair e compactar CF-e',
            path: '/cfe/extrair-cfe',
          },
          {
            key: 'monitoramento-cfe',
            label: 'Monitoramento CF-e',
            path: '/cfe/monitoramento-cfe',
          },
          {
            key: 'sped',
            label: 'SPED',
            path: '/financeiro/sped',
          },
          {
            key: 'gerenciador-notas-fiscais',
            label: 'Gerenciador Notas Fiscais',
            path: '/financeiro/gerenciador-notas-fiscais',
            permission: [
              ControleAcessoOperacoes.GerenciadorNfe,
              ControleAcessoOperacoes.GerenciadorNfeListar,
              ControleAcessoOperacoes.GerenciadorNfeAdicionar,
              ControleAcessoOperacoes.GerenciadorNfeAlterar,
              ControleAcessoOperacoes.GerenciadorNfeRemover,
            ],
          },
        ],
      },
      {
        key: 'tributacao',
        label: 'Tributação',
        subitems: [
          {
            key: 'aliquota',
            label: 'Alíquota',
            path: '/cadastro/aliquota',
            permission: [
              ControleAcessoOperacoes.Aliquota,
              ControleAcessoOperacoes.AliquotaListar,
              ControleAcessoOperacoes.AliquotaAdicionar,
              ControleAcessoOperacoes.AliquotaAlterar,
              ControleAcessoOperacoes.AliquotaRemover,
            ],
          },
          {
            key: 'cofins',
            label: 'COFINS',
            path: '/cadastro/cofins',
            permission: [
              ControleAcessoOperacoes.Cofins,
              ControleAcessoOperacoes.CofinsListar,
              ControleAcessoOperacoes.CofinsAdicionar,
              ControleAcessoOperacoes.CofinsAlterar,
              ControleAcessoOperacoes.CofinsRemover,
            ],
          },
          {
            key: 'pis',
            label: 'PIS',
            path: '/cadastro/pis',
            permission: [
              ControleAcessoOperacoes.Pis,
              ControleAcessoOperacoes.PisListar,
              ControleAcessoOperacoes.PisAdicionar,
              ControleAcessoOperacoes.PisAlterar,
              ControleAcessoOperacoes.PisRemover,
            ],
          },
          {
            key: 'categoria-tributaria',
            label: 'Categoria Tributaria',
            path: '/cadastro/categoria-tributaria',
            permission: [
              ControleAcessoOperacoes.CategoriaTributaria,
              ControleAcessoOperacoes.CategoriaTributariaListar,
              ControleAcessoOperacoes.CategoriaTributariaAdicionar,
              ControleAcessoOperacoes.CategoriaTributariaAlterar,
              ControleAcessoOperacoes.CategoriaTributariaRemover,
            ],
          },
        ],
      },
      {
        key: 'equipamentos-fiscais',
        label: 'Equipamentos',
        subitems: [
          {
            key: 'ecf',
            label: 'Impressora fiscal (ECF)',
            path: '/cadastro/ecf',
            permission: [
              ControleAcessoOperacoes.MaquinaECF,
              ControleAcessoOperacoes.MaquinaECFListar,
              ControleAcessoOperacoes.MaquinaECFAdicionar,
              ControleAcessoOperacoes.MaquinaECFAlterar,
              ControleAcessoOperacoes.MaquinaECFRemover,
            ],
          },
          {
            key: 'modelo-ecf',
            label: 'Modelo ECF',
            path: '/cadastro/modelo-ecf',
            permission: [
              ControleAcessoOperacoes.ModeloECF,
              ControleAcessoOperacoes.ModeloECFListar,
              ControleAcessoOperacoes.ModeloECFAdicionar,
              ControleAcessoOperacoes.ModeloECFAlterar,
              ControleAcessoOperacoes.ModeloECFRemover,
            ],
          },
          {
            key: 'sat',
            label: 'SAT',
            path: '/cadastro/sat',
            permission: [
              ControleAcessoOperacoes.SAT,
              ControleAcessoOperacoes.SATListar,
              ControleAcessoOperacoes.SATAdicionar,
              ControleAcessoOperacoes.SATAlterar,
              ControleAcessoOperacoes.SATRemover,
            ],
          },
          {
            key: 'marca-sat',
            label: 'Marca SAT',
            path: '/cadastro/marca-sat',
            permission: [
              ControleAcessoOperacoes.MarcaSAT,
              ControleAcessoOperacoes.MarcaSATListar,
              ControleAcessoOperacoes.MarcaSATAdicionar,
              ControleAcessoOperacoes.MarcaSATAlterar,
              ControleAcessoOperacoes.MarcaSATRemover,
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'financeiro',
    icon: <StockOutlined />,
    label: 'Financeiro',
    subitems: [
      {
        key: 'financeiro-cadastro',
        label: 'Cadastro',
        subitems: [
          {
            key: 'conta-a-pagar',
            label: 'Contas a pagar',
            path: '/financeiro/conta-a-pagar',
          },
          {
            key: 'ficha',
            label: 'Ficha financeira',
            path: '/cadastro/ficha',
            permission: [
              ControleAcessoOperacoes.FichaFinanceira,
              ControleAcessoOperacoes.FichaFinanceiraListar,
              ControleAcessoOperacoes.FichaFinanceiraAdicionar,
              ControleAcessoOperacoes.FichaFinanceiraAlterar,
              ControleAcessoOperacoes.FichaFinanceiraRemover,
            ],
          },
          {
            key: 'conta-corrente',
            label: 'Conta corrente',
            path: '/financeiro/conta-corrente',
          },
        ],
      },
      {
        key: 'financeiro-movimentacao',
        label: 'Movimentação',
        subitems: [
          {
            key: 'acerto-de-contas',
            label: 'Consolidação de Caixas (PDVs)',
            path: '/financeiro/acerto-de-contas',
          },
          {
            key: 'lancamento-financeiro',
            label: 'Lançamento financeiro',
            path: '/financeiro/lancamento-financeiro',
          },
        ],
      },
      {
        key: 'relatorios-financeiros',
        label: 'Relatórios',
        subitems: [
          {
            key: 'flash-caixa',
            label: 'Flash de caixa',
            path: '/relatorio/flash-caixa',
            permission: ControleAcessoOperacoes.FlashCaixa,
          },
          {
            key: 'crediario',
            label: 'Extrato de Crediário',
            path: '/relatorio/crediario',
            permission: ControleAcessoOperacoes.Crediario,
          },
          {
            key: 'saldo-devedor-crediario',
            label: 'Saldo devedor',
            path: '/relatorio/saldo-devedor-crediario',
            permission: ControleAcessoOperacoes.SaldoDevedor,
          },
          {
            key: 'troca-finalizadoras',
            label: 'Troca de finalizadoras',
            path: '/relatorio/troca-finalizadoras',
            permission: ControleAcessoOperacoes.TrocaFinalizadoras,
          },
          {
            key: 'lancamentos-financeiros',
            label: 'Lançamentos financeiros',
            path: '/relatorio/lancamentos-financeiros',
          },
          {
            key: 'acerto-contas-detalhe',
            label: 'Consolidação de Caixas (PDVs)',
            path: '/relatorio/acerto-contas-detalhe',
          },
          {
            key: 'ranking-adquirentes',
            label: 'Ranking Adquirentes',
            path: '/relatorio/ranking-adquirentes',
          },
        ],
      },
    ],
  },
  {
    key: 'estoque',
    icon: <GoldOutlined />,
    label: 'Estoque',
    subitems: [
      {
        key: 'entrada-nota',
        label: 'Entrada de Nota',
        path: '/financeiro/entrada-nota',
      },
      {
        key: 'local-estoque',
        label: 'Local de estoque (Em breve)',
        // path: '/estoque/local-estoque',
        permission: ControleAcessoOperacoes.LocalEstoque,
      },
      {
        key: 'transferencia-estoque',
        label: 'Transferência de estoque (Em breve)',
        // path: '/estoque/transferencia-estoque',
        permission: ControleAcessoOperacoes.TransferenciaEstoque,
      },
      {
        key: 'inventario',
        label: 'Inventário',
        path: '/estoque/inventario',
      },
      {
        key: 'producao',
        label: 'Produção',
        path: '/estoque/producao',
      },
      {
        key: 'relatorios-estoque',
        label: 'Relatórios',
        subitems: [
          {
            key: 'ajuste-estoque',
            label: 'Ajuste de estoque',
            path: '/relatorio/ajuste-estoque',
            permission: ControleAcessoOperacoes.AjusteEstoque,
          },
          {
            key: 'custo-estoque-total',
            label: 'Custo do estoque total',
            path: '/estoque/custo-estoque-total',
          },
          {
            key: 'estoque',
            label: 'Estoque',
            path: '/relatorio/estoque',
            permission: ControleAcessoOperacoes.Estoque,
          },
          {
            key: 'inventario-por-periodo',
            label: 'Relatório inventário por período',
            path: '/estoque/inventario-por-periodo',
          },
          {
            key: 'estoque-produto',
            label: 'Relatório estoque produto',
            path: '/estoque/estoque-produto',
          },
          {
            key: 'estoque-local',
            label: 'Relatório estoque local',
            path: '/estoque/estoque-local',
          },
          {
            key: 'transferencias-produto',
            label: 'Relatório transferencias de produto (Em breve)',
            // path: '/estoque/transferencias-produto',
            permission: ControleAcessoOperacoes.TransferenciasProduto,
          },
          {
            key: 'movimentacao-estoque',
            label: 'Relatório de movimentação de estoque (Em breve)',
            // path: '/estoque/movimentacao-estoque',
            permission: ControleAcessoOperacoes.MovimentacaoEstoque,
          },
        ],
      },
    ],
  },
  {
    key: 'integracoes',
    icon: <ApiOutlined />,
    label: 'Integrações',
    subitems: [
      {
        key: 'delivery-apps',
        label: 'Delivery e apps',
        subitems: [
          {
            key: 'ifood',
            label: 'iFood',
            path: '/integracao/ifood',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
          {
            key: 'rappi',
            label: 'Rappi',
            path: '/integracao/rappi',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
          {
            key: 'bysell',
            label: 'Bysell',
            path: '/integracao/bysell',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
          {
            key: 'anotaai',
            label: 'Anota AI',
            path: '/integracao/anotaai',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
          {
            key: '99food',
            label: '99 food',
            path: '/integracao/99food',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
        ],
      },
      {
        key: 'sistemas',
        label: 'Sistemas',
        subitems: [
          {
            key: 'varejofacil',
            label: 'Varejofacil',
            path: '/integracao/varejofacil',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
        ],
      },
      {
        key: 'easyassist',
        label: 'EasyAssist',
        subitems: [
          {
            key: 'eacardapio',
            label: 'EACardápio',
            path: '/integracao/eacardapio',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
          {
            key: 'eadelivery',
            label: 'EADelivery',
            path: '/integracao/eadelivery',
            permission: ControleAcessoOperacoes.Configuracoes,
          },
        ],
      },
      {
        key: 'exportacao-cardapio',
        label: 'Exportação Cardápio',
        path: '/integracao/exportacao-cardapio',
      },
    ],
  },
  {
    key: 'configuracoes',
    icon: <SettingOutlined />,
    label: 'Configurações',
    subitems: [
      {
        key: 'controle-acesso',
        label: 'Controle de acesso',
        path: '/controle-acesso',
        permission: ControleAcessoOperacoes.ControleAcesso,
      },
      {
        key: 'estabelecimento',
        label: 'Estabelecimento',
        path: '/estabelecimento',
        permission: [
          ControleAcessoOperacoes.Estabelecimento,
          ControleAcessoOperacoes.EstabelecimentoListar,
          ControleAcessoOperacoes.EstabelecimentoAdicionar,
          ControleAcessoOperacoes.EstabelecimentoAlterar,
          ControleAcessoOperacoes.EstabelecimentoRemover,
        ],
      },
      {
        key: 'parametros',
        label: 'Parâmetros de configuração',
        path: '/parametros',
        permission: ControleAcessoOperacoes.Configuracoes,
      },
      {
        key: 'acoes',
        label: 'Ações',
        path: '/acoes',
        permission: ControleAcessoOperacoes.Configuracoes,
      },
    ],
  },
]

export default menuItems
